import angular from 'angular';
import SourceErrorsService from './sourceErrors.service';

let sourceErrorsModule = angular.module('sourceErrors', []).service('sourceErrorsService', SourceErrorsService);

export default sourceErrorsModule;



// WEBPACK FOOTER //
// ./app/common/sourceErrors/sourceErrors.js